import { useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";
import { buildRecordPath } from "../../common/recordIdentifier";

interface Victimario {
    cedula: string;
    tipoFicha?: string;
    fichas?: number;
}

const RecordVictimarios = (props: any) => {
    const { id } = props;
    const [records, setRecords] = useState<Victimario[]>([]);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            const response = await API.getAction(`Busqueda/Victimarios?identifier=${id}`);
            if (response.data?.status === "ok") {
                setRecords(response.data.response || []);
            }
        } catch (error) {
            console.error("Error fetching victimarios:", error);
        }
    };

    useEffect(() => {
        if (id) bindRecords();
    }, [id]);

    if (records.length === 0) return null;

    return (
        <Card className="my-4 border-danger">
            <Card.Header className="display-5 bg-danger text-white py-2">
                <i className="fa fa-user-shield me-2" />
                {t("Victimaro (PIP)")}
            </Card.Header>
            <Card.Body className="p-0">
                <Table striped bordered size="sm" className="mb-0">
                    <thead>
                        <tr>
                            <th>{t("Cédula")}</th>
                            <th>{t("Tipo")}</th>
                            <th>{t("Imputaciones")}</th>
                            <th>{t("Perfil")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {records.map((r) => (
                            <tr key={r.cedula}>
                                <td>{r.cedula}</td>
                                <td>
                                    <span className="badge bg-danger">{r.tipoFicha || "PIP"}</span>
                                </td>
                                <td>{r.fichas ?? "—"}</td>
                                <td>
                                    <a
                                        href={buildRecordPath(r.cedula)}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-sm btn-outline-danger"
                                    >
                                        <i className="fa fa-external-link-alt me-1" />
                                        {t("Ver")}
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};

export default RecordVictimarios;
